/* Grace Theory — product page */
(function () {
  function init(root) {
    if (!root || root.dataset.gtReady) return;
    root.dataset.gtReady = '1';

    var dataEl = root.querySelector('[data-gt-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var form = root.querySelector('#GtProductForm');
    var idInput = root.querySelector('[data-gt-variant-id]');
    var atc = root.querySelector('[data-gt-atc]');
    var atcLabel = root.querySelector('[data-gt-atc-label]');
    var priceEl = root.querySelector('[data-gt-price]');
    var barPrice = root.querySelector('[data-gt-bar-price]');
    var errorEl = root.querySelector('[data-gt-error]');
    var colorLabel = root.querySelector('[data-gt-color-label]');
    var slidesWrap = root.querySelector('[data-gt-slides]');
    var counterCur = root.querySelector('[data-gt-count-current]');
    var counterTotal = root.querySelector('[data-gt-count-total]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-gt-option]'));
    var colorPos = data.colorPos || 0;

    /* ---------- variant selection ---------- */
    function selectedOptions() {
      var sel = [];
      for (var i = 0; i < data.optionCount; i++) sel.push(null);
      fieldsets.forEach(function (fs) {
        var pos = parseInt(fs.dataset.gtOption, 10);
        var checked = fs.querySelector('input:checked');
        sel[pos - 1] = checked ? checked.value : null;
      });
      return sel;
    }

    function findVariant(sel) {
      if (data.defaultOnly) return data.variants[0];
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] === null || v.options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function missingOption(sel) {
      for (var j = 0; j < sel.length; j++) if (sel[j] === null) return j + 1;
      return 0;
    }

    function markAvailability(sel) {
      // Strike through values that are sold out for the other current selections
      fieldsets.forEach(function (fs) {
        var pos = parseInt(fs.dataset.gtOption, 10);
        if (pos === colorPos) return;
        fs.querySelectorAll('input').forEach(function (input) {
          var test = sel.slice();
          test[pos - 1] = input.value;
          var available = data.variants.some(function (v) {
            for (var j = 0; j < test.length; j++) {
              if (test[j] !== null && v.options[j] !== test[j]) return false;
            }
            return v.available;
          });
          input.parentElement.classList.toggle('is-soldout', !available);
        });
      });
    }

    function setPrice(v) {
      if (!v) return;
      var html = (v.compare ? '<s class="gt-pdp__compare">' + v.compare + '</s>' : '') + '<span>' + v.price + '</span>';
      if (priceEl) priceEl.innerHTML = html;
      if (barPrice) barPrice.textContent = v.price;
    }

    function update(fromUser) {
      var sel = selectedOptions();
      var v = findVariant(sel);
      var missing = missingOption(sel);

      fieldsets.forEach(function (fs) {
        var lab = fs.querySelector('[data-gt-option-label]');
        var checked = fs.querySelector('input:checked');
        if (lab) lab.textContent = checked ? checked.value : '';
      });
      if (colorLabel && colorPos) colorLabel.textContent = sel[colorPos - 1] || '';
      showModelFor(colorPos ? sel[colorPos - 1] : null);

      markAvailability(sel);
      if (errorEl) errorEl.hidden = true;

      var state = 'instock';
      if (v) {
        idInput.value = v.id;
        setPrice(v);
        state = !v.available ? 'soldout' : (v.preorder ? 'preorder' : 'instock');
        if (fromUser && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else if (missing) {
        // size not chosen yet: judge by the selected colour
        var inColour = data.variants.filter(function (x) { return !colorPos || x.options[colorPos - 1] === sel[colorPos - 1]; });
        setPrice(inColour[0]);
        var avail = inColour.filter(function (x) { return x.available; });
        state = !avail.length ? 'soldout' : (avail.every(function (x) { return x.preorder; }) ? 'preorder' : 'instock');
      } else {
        state = 'unavailable';
      }
      applyStockState(state, v, !!missing);
      root.classList.toggle('gt-needs-option', !!missing);
      if (colorPos) filterGallery(sel[colorPos - 1]);
    }

    /* ---------- sold out / pre-order / remind me ---------- */
    var stockBadge = root.querySelector('[data-gt-stock-badge]');
    var preorderNote = root.querySelector('[data-gt-preorder-note]');
    var notify = root.querySelector('[data-gt-notify]');
    var notifyOpen = root.querySelector('[data-gt-notify-open]');
    var notifyPanel = root.querySelector('[data-gt-notify-panel]');
    var notifyEmail = root.querySelector('[data-gt-notify-email]');
    var notifySubmit = root.querySelector('[data-gt-notify-submit]');
    var notifyMsg = root.querySelector('[data-gt-notify-msg]');
    var currentStock = { state: 'instock', variant: null };

    function applyStockState(state, v, missing) {
      currentStock = { state: state, variant: v };
      var soldOut = state === 'soldout';
      var useNotify = soldOut && notify && data.soldOutAction === 'notify';

      // Client brief: stock 0 => image badge always says "Sold out"; only the button changes (Remind me / Pre-order)
      if (stockBadge) {
        stockBadge.hidden = !(soldOut || state === 'preorder');
        stockBadge.textContent = data.soldOutLabel || 'Sold out';
        stockBadge.classList.add('gt-badge--soldout');
      }
      if (preorderNote) preorderNote.hidden = state !== 'preorder';

      atc.hidden = useNotify;
      if (notify) {
        notify.hidden = !useNotify;
        if (!useNotify && notifyPanel) { notifyPanel.hidden = true; if (notifyOpen) notifyOpen.hidden = false; }
      }
      if (state === 'unavailable') {
        atc.disabled = true; atcLabel.textContent = 'Unavailable';
      } else if (soldOut) {
        atc.disabled = true; atcLabel.textContent = data.soldOutLabel || 'Sold out';
      } else {
        atc.disabled = false;
        atcLabel.textContent = state === 'preorder' ? (data.preorderLabel || 'Pre-order') : (data.atcLabel || 'Add to cart');
      }
      var barBtnEl = root.querySelector('[data-gt-bar-label]');
      if (barBtnEl) {
        barBtnEl.textContent = useNotify ? (notifyOpen ? notifyOpen.textContent : 'Remind me') : atcLabel.textContent;
      }
    }

    if (notifyOpen) {
      notifyOpen.addEventListener('click', function () {
        notifyOpen.hidden = true;
        notifyPanel.hidden = false;
        notifyMsg.hidden = true;
        notifyEmail.focus();
      });
    }
    function sendNotify() {
      var v = currentStock.variant;
      var email = (notifyEmail.value || '').trim();
      notifyMsg.hidden = true;
      notifyMsg.classList.remove('is-error');
      if (!v) {
        var sel = selectedOptions();
        var miss = missingOption(sel);
        if (miss) { flashMissing(miss); errorEl.hidden = true; }
        notifyMsg.textContent = 'Please choose your size first.';
        notifyMsg.classList.add('is-error'); notifyMsg.hidden = false;
        return;
      }
      if (!email || !notifyEmail.checkValidity() || email.indexOf('@') < 1) {
        notifyMsg.textContent = 'Please enter a valid email address.';
        notifyMsg.classList.add('is-error'); notifyMsg.hidden = false;
        return;
      }
      if (!data.klaviyoKey) {
        notifyMsg.textContent = 'Back-in-stock alerts are not set up yet.';
        notifyMsg.classList.add('is-error'); notifyMsg.hidden = false;
        return;
      }
      notifySubmit.disabled = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(data.klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } }
          }
        })
      }).then(function (res) {
        if (res.ok) {
          notifyMsg.textContent = data.notifySuccess || "Thank you. We'll email you as soon as it's available.";
          notifyMsg.hidden = false;
          notifyEmail.value = '';
        } else {
          notifyMsg.textContent = 'Something went wrong. Please try again.';
          notifyMsg.classList.add('is-error'); notifyMsg.hidden = false;
        }
      }).catch(function () {
        notifyMsg.textContent = 'Something went wrong. Please try again.';
        notifyMsg.classList.add('is-error'); notifyMsg.hidden = false;
      }).finally(function () { notifySubmit.disabled = false; });
    }
    if (notifySubmit) {
      notifySubmit.addEventListener('click', sendNotify);
      notifyEmail.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); sendNotify(); }   /* don't submit the product form */
      });
    }

    /* ---------- model info per colour ---------- */
    var modelLines = Array.prototype.slice.call(root.querySelectorAll('[data-gt-model-color]'));
    function showModelFor(color) {
      if (!modelLines.length) return;
      var key = (color || '').toLowerCase();
      var hasMatch = modelLines.some(function (el) { return el.dataset.gtModelColor === key; });
      // Each place (gallery card, size guide, accordion) holds its own set of lines
      var groups = [];
      modelLines.forEach(function (el) { if (groups.indexOf(el.parentNode) === -1) groups.push(el.parentNode); });
      groups.forEach(function (parent) {
        var lines = modelLines.filter(function (el) { return el.parentNode === parent; });
        var shownFirst = false;
        lines.forEach(function (el) {
          var c = el.dataset.gtModelColor;
          var show = hasMatch ? (c === key || c === '') : (c === '' || !shownFirst);
          if (show && c !== '') shownFirst = true;
          el.hidden = !show;
        });
      });
    }
    /* ---------- gallery ---------- */
    var slides = slidesWrap ? Array.prototype.slice.call(slidesWrap.children) : [];
    function visibleSlides() {
      return slides.filter(function (el) { return !el.hidden; });
    }
    function filterGallery(color) {
      if (!color) return;
      var key = color.toLowerCase();
      var anyTagged = slides.some(function (el) { return el.dataset.color; });
      if (!anyTagged) return;
      var anyMatch = slides.some(function (el) { return el.dataset.color === key; });
      slides.forEach(function (el) {
        el.hidden = anyMatch ? !(el.dataset.color === key || el.dataset.color === '') : false;
      });
      if (slidesWrap) slidesWrap.scrollLeft = 0;
      updateCounter();
    }
    function updateCounter() {
      var vis = visibleSlides();
      if (counterTotal) counterTotal.textContent = vis.length;
      if (!slidesWrap || !counterCur) return;
      var w = slidesWrap.clientWidth || 1;
      var idx = Math.round(slidesWrap.scrollLeft / w);
      counterCur.textContent = Math.min(vis.length, idx + 1);
    }
    if (slidesWrap) slidesWrap.addEventListener('scroll', function () { window.requestAnimationFrame(updateCounter); }, { passive: true });

    /* ---------- add to bag ---------- */
    function flashMissing(pos) {
      var fs = root.querySelector('[data-gt-option="' + pos + '"]');
      if (!fs) return;
      fs.classList.remove('is-flash');
      void fs.offsetWidth;
      fs.classList.add('is-flash');
      if (errorEl) {
        var legend = fs.querySelector('.gt-opt__label');
        var name = legend ? legend.firstChild.textContent.trim().toLowerCase() : 'size';
        errorEl.textContent = 'Please select a ' + name + '.';
        errorEl.hidden = false;
      }
      var rect = fs.getBoundingClientRect();
      if (rect.top < 80 || rect.bottom > window.innerHeight) {
        window.scrollTo({ top: window.pageYOffset + rect.top - 120, behavior: 'smooth' });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = selectedOptions();
      var missing = missingOption(sel);
      if (missing && !data.defaultOnly) { flashMissing(missing); return; }
      var v = findVariant(sel);
      if (!v || !v.available) return;

      atc.classList.add('is-loading');
      atc.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            errorEl.textContent = res.body.description || res.body.message || 'Could not add to bag.';
            errorEl.hidden = false;
            return;
          }
          atcLabel.textContent = 'Added';
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && document.querySelector('m-cart-items')) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          }
          setTimeout(function () { atcLabel.textContent = currentStock.state === 'preorder' ? (data.preorderLabel || 'Pre-order') : (data.atcLabel || 'Add to cart'); }, 1800);
        })
        .catch(function () {
          errorEl.textContent = 'Could not add to bag. Please try again.';
          errorEl.hidden = false;
        })
        .finally(function () {
          atc.classList.remove('is-loading');
          atc.disabled = false;
        });
    });

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { update(true); });
    });

    /* ---------- size guide drawer ---------- */
    var guide = root.querySelector('[data-gt-guide]');
    root.querySelectorAll('[data-gt-open-guide]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (guide && guide.showModal) { guide.showModal(); document.documentElement.classList.add('gt-lock'); }
        else { var p = document.getElementById('size-guide'); if (p) p.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
    if (guide) {
      guide.addEventListener('close', function () { document.documentElement.classList.remove('gt-lock'); });
      guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
      var c = guide.querySelector('[data-gt-close-guide]');
      if (c) c.addEventListener('click', function () { guide.close(); });
    }

    /* ---------- zoom ---------- */
    var zoom = root.querySelector('[data-gt-zoom-dialog]');
    var zoomImg = root.querySelector('[data-gt-zoom-img]');
    root.querySelectorAll('[data-gt-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!zoom || !zoom.showModal || window.matchMedia('(max-width: 749px)').matches) return;
        zoomImg.src = btn.dataset.gtZoom;
        zoomImg.alt = (btn.querySelector('img') || {}).alt || '';
        zoom.showModal();
        document.documentElement.classList.add('gt-lock');
      });
    });
    if (zoom) {
      zoom.addEventListener('close', function () { document.documentElement.classList.remove('gt-lock'); });
      zoom.addEventListener('click', function () { zoom.close(); });
    }

    /* ---------- mobile sticky bar ---------- */
    var bar = root.querySelector('[data-gt-bar]');
    var barBtn = root.querySelector('[data-gt-bar-btn]');
    if (bar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        barBtn.tabIndex = show ? 0 : -1;
      });
      io.observe(atc);
      barBtn.addEventListener('click', function () {
        var sel = selectedOptions();
        var missing = missingOption(sel);
        if (currentStock.state === 'soldout' && notify && !notify.hidden) { notify.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (notifyOpen && !notifyOpen.hidden) notifyOpen.click(); return; }
        if (missing && !data.defaultOnly) { flashMissing(missing); return; }
        form.requestSubmit ? form.requestSubmit() : atc.click();
      });
    }

    /* ---------- model info ---------- */
    var modelBtn = root.querySelector('[data-gt-model-btn]');
    if (modelBtn) {
      var modelCard = document.getElementById(modelBtn.getAttribute('aria-controls'));
      modelBtn.addEventListener('click', function () {
        var open = modelBtn.getAttribute('aria-expanded') === 'true';
        modelBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (modelCard) modelCard.hidden = open;
      });
    }

    /* ---------- size guide units (cm / inches) ---------- */
    root.querySelectorAll('[data-gt-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.dataset.gtUnit;
        root.querySelectorAll('[data-gt-unit]').forEach(function (b) {
          var on = b.dataset.gtUnit === unit;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('td[data-cm]').forEach(function (td) {
          var cm = parseFloat(String(td.dataset.cm).replace(',', '.'));
          if (isNaN(cm)) return;
          td.textContent = unit === 'in' ? (Math.round(cm / 2.54 * 10) / 10).toString() : td.dataset.cm;
        });
      });
    });

    /* ---------- two-way sticky: a column taller than the viewport sticks by its bottom ---------- */
    var stickyCols = [root.querySelector('.gt-pdp__gallery'), root.querySelector('.gt-pdp__info')].filter(Boolean);
    function setStickyTops() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        stickyCols.forEach(function (el) { el.style.top = ''; });
        return;
      }
      var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gt-header-h'), 10) || 72;
      var base = header + 16;
      stickyCols.forEach(function (el) {
        var fit = window.innerHeight - el.offsetHeight - 16;
        el.style.top = Math.min(base, fit) + 'px';
      });
    }
    setStickyTops();
    window.addEventListener('resize', setStickyTops);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(setStickyTops);
      stickyCols.forEach(function (el) { ro.observe(el); });
    }

    update(false);
    updateCounter();
  }

  function boot() {
    document.querySelectorAll('[data-gt-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
